module.exports = __webpack_public_path__ + "img/mx.0fc74fab.svg";